/* eslint-disable */
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import dayjs from "utils/dayjs";
import { Chip, TableContainer, Table, TableRow, TableCell, TextField, Button, TableBody } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Resizer from "react-image-file-resizer";
import { getEquipmentCategoriesByQuery } from "components/axios/equipmentCategoryAxios";
import { deleteEquipments, getEquipmentCtgr1ByZone, getEquipmentsByQuery, getLiftControlPanelsQuery } from "components/axios/equipmentAxios";
import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";
import CustomFormEquipmentSelect from "components/select/CustomFormEquipmentSelect";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import MainCard from "components/MainCard";
import FileDownloadIcon from "components/FileDownloadIcon";
import { useEnumApi } from "contexts/EnumApiContext";
import CustomDatePicker from "components/date_picker/CustomDatePicker";
import { customFileAxios } from "components/axios/customAxios";
import CompanyWriteLayer from "components/layer/CompanyWriteLayer";
import ManagementCompanyZoneWriteLayer from "components/layer/ManagementCompanyZoneWriteLayer";
import { getCompaniesByQuery } from "components/axios/companyAxios";
import { getManagementEquipmentZonesByCompanyId } from "components/axios/equipmentZoneAxios";
import { nowFormat, toServerDateOnly } from "components/date_picker/dateUtils";
import { writeAuditLog } from "components/axios/auditLogger";

const EquipmentForm = ({info, onRefresh, setEquipmentNoList}) => {
    const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
    const nantongCompanyId = process.env.REACT_APP_NANTONG_MANAGEMENT_COMPANY_NO;
    
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s:level1s } = useEnumApi();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const navigate = useNavigate();
    // const [equipmentCategoryLevel1s, setEquipmentCategoryLevel1s] = useState(null);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState(null);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState(null);
    const [liftControlPanels, setLiftControlPanels] = useState(null);
  
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    // const [equipmentCategoryLevel1Code, setEquipmentCategoryLevel1Code] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
    // const [isLoading, setIsLoading] = useState(false);
    
    // const [imgFile, setImgFile] = useState(null);
    const [bpFile, setBpFile] = useState(null);
    const [vrFile, setVrFile] = useState(null);
    // const [imgFileId, setImgFileId] = useState(null);
    const [bpFileId, setBpFileId] = useState(null);
    const [fileLoading, setFileLoading] = useState(false);
    const [inputImageItems, setInputImageItems] = useState([]);

    const nextImgID = useRef(1);
    const nextVRID = useRef(1);
    const nextID = useRef(1);
    const [inputVRItems, setInputVRItems] = useState([
         { id: 1, file: null, vId : null, vFile: null }, { id: 2, file: null, vId : null, vFile: null }, { id: 3, file: null, vId : null, vFile: null }, { id: 4, file: null, vId : null, vFile: null }
        ,{ id: 5, file: null, vId : null, vFile: null }, { id: 6, file: null, vId : null, vFile: null }, { id: 7, file: null, vId : null, vFile: null }, { id: 8, file: null, vId : null, vFile: null }
    ]);
    const [inputManualItems, setInputManualItems] = useState([]);

    const [companies, setCompanies] = useState([]);
    const [zones, setZones] = useState([]);
    const [manageCompanies, setManageCompanies] = useState([]);
    const [maintenanceCompanies, setMaintenanceCompanies] = useState([]);
    const [manufacturingCompanies, setManufacturingCompanies] = useState([]);
    const [addCompany, setAddCompany] = useState(null);
    const [managementCompany, setManagementCompany] = useState(null);
    const [managementCompanyZone, setManagementCompanyZone] = useState(null);
    const [maintenanceCompany, setMaintenanceCompany] = useState(null);
    const [manufacturingCompany, setManufacturingCompany] = useState(null);
   
    const useSelects = [{id: 0, name: t('message.common.subtitle.empty')},{id: 1, name: t('message.common.subtitle.exist')}];
    // const [isFirst, setIsFirst] = useState(true);
    const [isCompanyLoading, setIsCompanyLoading] = useState(false);
    const [selectManagementCompany, setSelectManagementCompany] = useState(platformServer === 'NANTONG' ? nantongCompanyId : null);
    const [selectManufacturingCompany, setSelectManufacturingCompany] = useState(null);
    const [selectMaintenanceCompany, setSelectMaintenanceCompany] = useState(null);
    const [selectManagementCompanyZone, setSelectManagementCompanyZone] = useState(null);

    const { control, register, handleSubmit, setValue, formState : {isDirty, errors } } = useForm({});
 
    // const manufacturingCompanyArray = useFieldArray({ control, name: "manufacturingCompanyArray" });
    // const maintenanceCompanyArray = useFieldArray({ control, name: "maintenanceCompanyArray" });

    // function fileChangedHandler(event, maxWith, maxHeight, responseUriFunc) {
    //     if (event.target?.files?.[0]) {
    //       try {
    //         Resizer.imageFileResizer(event.target.files[0], maxWith, maxHeight, "JPEG", 90, 0, responseUriFunc, "file", 0, 0)
    //       } catch (err) {
    //         handleAlertClick(err.message);
    //         responseUriFunc('')
    //       }
    //     }
    // }

    // 가로사이즈 비교하여 비율대로 리사이즈
    function fileChangedHandler(event, maxWidth = 1920, maxHeight = 1920, responseUriFunc) {
        const file = event.target?.files?.[0];
        if (!file) return;

        try {
            const img = new Image();
            const reader = new FileReader();

            reader.onload = e => {
                img.src = e.target.result;
            };

            img.onload = () => {
                const { width, height } = img;

                // 👉 가로가 maxWidth 이하 → 리사이즈 안 함
                if (width <= maxWidth) {
                    responseUriFunc(file);
                    return;
                }

                // 👉 비율 유지 계산
                const resizeWidth = maxWidth;
                const resizeHeight = Math.round((height / width) * resizeWidth);

                Resizer.imageFileResizer(
                    file,
                    resizeWidth,
                    resizeHeight,
                    "JPEG",
                    90,
                    0,
                    responseUriFunc,
                    "file",
                    resizeWidth,
                    resizeHeight
                );
            };

            reader.readAsDataURL(file);
        } catch (err) {
            handleAlertClick(err.message);
            responseUriFunc('');
        }
    }

    // 가로·세로 중 큰 쪽 기준 자동 리사이즈
    // function fileChangedHandler(event, maxWidth = 1920, maxHeight = 1920, responseUriFunc) {
    //     const file = event.target?.files?.[0];
    //     if (!file) return;

    //     try {
    //         const img = new Image();
    //         const reader = new FileReader();

    //         reader.onload = e => {
    //             img.src = e.target.result;
    //         };

    //         img.onload = () => {
    //             const { width, height } = img;

    //             // 👉 둘 중 큰 쪽 기준으로만 리사이즈
    //             if (width <= maxWidth && height <= maxHeight) {
    //                 responseUriFunc(file);
    //                 return;
    //             }

    //             const isLandscape = width >= height;

    //             const resizeWidth = isLandscape
    //                 ? maxWidth
    //                 : Math.round((width / height) * maxHeight);

    //             const resizeHeight = isLandscape
    //                 ? Math.round((height / width) * maxWidth)
    //                 : maxHeight;

    //             Resizer.imageFileResizer(
    //                 file,
    //                 resizeWidth,
    //                 resizeHeight,
    //                 "JPEG",
    //                 90,
    //                 0,
    //                 responseUriFunc,
    //                 "file",
    //                 resizeWidth,
    //                 resizeHeight
    //             );
    //         };

    //         reader.readAsDataURL(file);
    //     } catch (err) {
    //         handleAlertClick(err.message);
    //         responseUriFunc('');
    //     }
    // }

    // const resizeFile = (file, maxWidth, maxHeight) =>
    //     new Promise((res) => {
    //         Resizer.imageFileResizer(
    //             file, // target file
    //             maxWidth, // maxWidth
    //             maxHeight, // maxHeight
    //             "JPEG", // compressFormat : Can be either JPEG, PNG or WEBP.
    //             90, // quality : 0 and 100. Used for the JPEG compression
    //             0, // rotation
    //             (uri) => res(uri), // responseUriFunc
    //             "file" // outputType : Can be either base64, blob or file.(Default type is base64)
    //             ,0,0	
    //         );
    //     }
    // );

    const resizeFile = (file, maxWidth = 1920, maxHeight = 1080) =>
        new Promise((resolve, reject) => {
            const img = new Image();
            const reader = new FileReader();

            reader.onload = e => {
            img.src = e.target.result;
            };

            img.onload = () => {
            const { width, height } = img;

            // 👉 둘 다 제한 이하면 리사이즈 안 함
            if (width <= maxWidth && height <= maxHeight) {
                resolve(file);
                return;
            }

            // 👉 비율 유지 계산 (제한을 벗어난 쪽 기준)
            const widthRatio = maxWidth / width;
            const heightRatio = maxHeight / height;
            const ratio = Math.min(widthRatio, heightRatio);

            const resizeWidth = Math.round(width * ratio);
            const resizeHeight = Math.round(height * ratio);

            Resizer.imageFileResizer(
                file,
                resizeWidth,
                resizeHeight,
                "JPEG",
                90,
                0,
                uri => resolve(uri),
                "file"
            );
            };

            img.onerror = reject;
            reader.onerror = reject;

            reader.readAsDataURL(file);
        });

    // useEffect(()=> {
    //     getEquipmentCtgr1ByZone().then((data)=>{
    //         setEquipmentCategoryLevel1s(data)
    //     })
    // }, [])

    useEffect(() => {
        Promise.all([
            getLiftControlPanelsQuery().then((data) => {
                if (data) {
                    setLiftControlPanels([{id:0, name:t('message.common.subtitle.panel')}, 
                        ...data.map(d=> {return {id:d.id, name:d.firmwareVersion ? `${d.modelName} [${d.firmwareVersion}]` : d.modelName}})])
                    // setLiftControlPanels(data);
                } else {
                    setLiftControlPanels([{id:0, name:t('message.common.subtitle.panel')}]);
                }
            }),
            getCompaniesByQuery({loginActiveStatus:"ne(STP)"}).then((res)=>{
                if (res) {
                    setCompanies(res._embedded.companies);
                    return res._embedded.companies;
                } else {
                    return null;
                }
            })
        ]).then((res2)=>{
            if (res2[1]) {
                const manCompanies = res2[1].filter((comp)=>comp.type === 'MAN').map((comp) => ({ id : comp.id, name:comp.info.name }));
                if (manCompanies) setManageCompanies(manCompanies);
                const mfrCompanies = res2[1].filter((comp)=>comp.type === 'MFR').map((comp) => ({ id : comp.id, name:comp.info.name }));
                if (mfrCompanies) setManufacturingCompanies(mfrCompanies);
                const mntCompanies = res2[1].filter((comp)=>comp.type === 'MNT').map((comp) => ({ id : comp.id, name:comp.info.name }));
                if (mntCompanies) setMaintenanceCompanies(mntCompanies);
            }
        })
    }, [level1s]);

    useEffect(()=> {
        if (!isCompanyLoading) {
            // console.log('업체목록')
            // console.log(addCompany)
            if (addCompany) {
                if (addCompany.type === 'MAN') {
                    // console.log(managementCompany)
                    if (managementCompany) {
                        // console.log([...(companies.filter((comp)=>comp.type === 'MAN').map((comp) => ({ id : comp.id, name:comp.info.name }))), {id:0, name:addCompany.info.name}])
                        setManageCompanies([...(companies.filter((comp)=>comp.type === 'MAN').map((comp) => ({ id : comp.id, name:comp.info.name }))), {id:0, name:addCompany.info.name}]);
                    } else {
                        // console.log([...manageCompanies, {id:0, name:addCompany.info.name}])
                        setManageCompanies([...manageCompanies, {id:0, name:addCompany.info.name}]);
                    }
                    setManagementCompany(addCompany);
                    setSelectManagementCompany(0)
                    setValue('managementCompanyId', 0)
                } else if (addCompany.type === 'MNT') {
                    // console.log(maintenanceCompany)
                    if (maintenanceCompany) {
                        setMaintenanceCompanies([...(companies.filter((comp)=>comp.type === 'MNT').map((comp) => ({ id : comp.id, name:comp.info.name }))), {id:0, name:addCompany.info.name}]);
                    } else {
                        setMaintenanceCompanies([...maintenanceCompanies, {id:0, name:addCompany.info.name}]);
                    }
                    setMaintenanceCompany(addCompany);
                    setSelectMaintenanceCompany(0)
                    setValue('maintenanceCompanyId', 0)
                } else if (addCompany.type === 'MFR') {
                    // console.log(manufacturingCompany)
                    if (manufacturingCompany) {
                        setManufacturingCompanies([...(companies.filter((comp)=>comp.type === 'MFR').map((comp) => ({ id : comp.id, name:comp.info.name }))), {id:0, name:addCompany.info.name}]);
                    } else {
                        setManufacturingCompanies([...manufacturingCompanies, {id:0, name:addCompany.info.name}]);
                    }
                    setManufacturingCompany(addCompany);
                    setSelectManufacturingCompany(0)
                    setValue('manufacturingCompanyId', 0)
                }
            }
            
            setIsCompanyLoading(true);
        }
    },[isCompanyLoading]);


    useEffect(() => {
        // console.log(selectManagementCompany)
        if (selectManagementCompany && selectManagementCompany != 0) {
            getManagementEquipmentZonesByCompanyId(selectManagementCompany).then((res) => {
                // console.log(res)
                setZones(res);
            })
        } else {
            setZones([]);
            setValue('zoneId', '');
            setSelectManagementCompanyZone(null);
            setManagementCompanyZone(null);
        }
    }, [selectManagementCompany])

    useEffect(() => {
        // console.log(managementCompanyZone)
        if (managementCompanyZone) {
            // console.log(zones)
            setSelectManagementCompanyZone(0)
            setValue('zoneId', 0)
            setZones([...zones, {id:0, ...managementCompanyZone}]);
            // console.log([...zones, {id:0, ...managementCompanyZone}])
        // } else {
        //     console.log(11111)
        //     setValue('zoneId', '');
        //     setSelectManagementCompanyZone(null);
        //     setZones([])
        }
    }, [managementCompanyZone])

    // 설비중분류 목록
    useEffect(()=>{
        if (equipmentCategoryLevel1Id) {
            const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentCategories;
                    if (list) {
                        setEquipmentCategoryLevel2s(list);
                        let sId = (equipmentCategoryLevel2Id || (info && info.equipmentCtgr && info.equipmentCtgr.parent && info.equipmentCtgr.parent.id) || '');
                        setEquipmentCategoryLevel2Id(sId);
                        let belongDatas = data._embedded.equipmentCategories.filter(item=> item.id == sId);
                        if (equipmentCategoryLevel2Id && belongDatas && belongDatas.length > 0) {
                            setValue("equipmentCategoryLevel2Id", equipmentCategoryLevel2Id);
                        } else if (info && info.equipmentCtgr && info.equipmentCtgr.parent) {
                            setValue("equipmentCategoryLevel2Id", (info.equipmentCtgr.parent.id || null));
                        } else {
                            setValue("equipmentCategoryLevel2Id", '');
                        }
                    } else {
                        setEquipmentCategoryLevel2Id('');
                        setValue("equipmentCategoryLevel2Id",'');
                        setEquipmentCategoryLevel2s([]);
                    }
                    setEquipmentCategoryLevel3Id('');
                    setValue("equipmentCategoryLevel3Id",'');
                    setEquipmentCategoryLevel3s([]);
                } else {
                    setEquipmentCategoryLevel2Id('');
                    setValue("equipmentCategoryLevel2Id",'');
                    setEquipmentCategoryLevel2s([]);

                    setEquipmentCategoryLevel3Id('');
                    setValue("equipmentCategoryLevel3Id",'');
                    setEquipmentCategoryLevel3s([]);
                }
            });
        }
    },[equipmentCategoryLevel1Id]);

    // 설비분류 목록
    useEffect(()=>{
        if (equipmentCategoryLevel2Id) {
            const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentCategories;
                    if (list) {
                        setEquipmentCategoryLevel3s(list);
                        let sId = (equipmentCategoryLevel3Id || (info && info.equipmentCtgr && info.equipmentCtgr.id) || '');
                        setEquipmentCategoryLevel3Id(sId);
                        let belongDatas = data._embedded.equipmentCategories.filter(item=> item.id == sId);
                        if (equipmentCategoryLevel3Id && belongDatas && belongDatas.length > 0) {
                            setValue("equipmentCategoryLevel3Id", equipmentCategoryLevel3Id);
                        } else if (info && info.equipmentCtgr) {
                            setValue("equipmentCategoryLevel3Id", (info.equipmentCtgr.id || null));
                        } else {
                            setEquipmentCategoryLevel3Id('');
                            setValue("equipmentCategoryLevel3Id", '');
                          }
                      } else {
                          setEquipmentCategoryLevel3Id('');
                          setValue("equipmentCategoryLevel3Id", '');
                          setEquipmentCategoryLevel3s([]);
                      }
                  } else {
                      setEquipmentCategoryLevel3Id('');
                      setValue("equipmentCategoryLevel3Id", '');
                      setEquipmentCategoryLevel3s([]);
                }
            });
        }
    },[equipmentCategoryLevel2Id]);
    
    useEffect(()=>{
        if (info) {
            if (info.equipmentCtgr) {
                if (info.equipmentCtgr.parent) {
                    if (info.equipmentCtgr.parent.parent) {
                        setEquipmentCategoryLevel1Id(info.equipmentCtgr.parent.parent.id);
                        // setEquipmentCategoryLevel1Code(info.equipmentCtgr.parent.parent.code);
                    }
                    setEquipmentCategoryLevel2Id(info.equipmentCtgr.parent.id);
                }
            }
            setValue("opStatus", info.opStatus || '');
            setValue("madeYmd", info.madeYmd || null);
            setValue("instlYmd", info.instlYmd || null);
            setValue("disposalYmd", info.disposalYmd || null);
            setValue("name", info.name || '');
            setValue("equipmentNo", info.equipmentNo || '');
            setValue("location", info.location || '');
            setValue("modelName", info.modelName || '');
            setValue("remark", info.remark || '');
            setValue("controlPanelId", info?.controlPanel?.id || 0);
            setValue("manufacturingCompanyYn", info?.manufacturingCompany?.id ? 1 : 0);
            setValue("maintenanceCompanyYn", info?.maintenanceCompany?.id ? 1 : 0);

            // setValue("")
            if (info.managementCompany?.id) {
                setSelectManagementCompany(info.managementCompany?.id)
                setValue("managementCompanyId", info.managementCompany?.id || '');
            }
            if (info.maintenanceCompany?.id) {
                setSelectMaintenanceCompany(info.maintenanceCompany?.id)
                setValue("maintenanceCompanyId", info.maintenanceCompany?.id || '');
            }
            if (info.manufacturingCompany?.id) {
                setSelectManufacturingCompany(info.manufacturingCompany?.id)
                setValue("manufacturingCompanyId", info.manufacturingCompany?.id || '');
            }
            if (info.zone?.id) {
                setSelectManagementCompanyZone(info.zone?.id)
                setValue("zoneId", info.zone?.id || '');
            }

            // setImgFileId((info.imgFile && (info.imgFile.id || null)));
            setBpFileId((info.bpFile && (info.bpFile.id || null)));

            if (info.imgFiles) {
                let inputImageItemsCopy = [];
                nextImgID.current = 1;
                for (var j=0;j<info.imgFiles.length;j++) {
                    const input = {	
                        id: nextImgID.current,
                        file: {},
                        imgFile: info.imgFiles[j],
                    };
                    inputImageItemsCopy = [...inputImageItemsCopy, input]
                    nextImgID.current += 1;
                }
                setInputImageItems(inputImageItemsCopy);
            }

            if (info.vrFiles) {
                let inputVRItemsCopy = [...inputVRItems];
                for (var i=0;i<info.vrFiles.length;i++) {
                    var vFileIdx = inputVRItems.findIndex(item => item.id === info.vrFiles[i].sortOrder);
                    //console.log(vFileIdx)
                    inputVRItemsCopy[vFileIdx].vId = info.vrFiles[i].id;
                    inputVRItemsCopy[vFileIdx].vFile = info.vrFiles[i].file;
                }
                setInputVRItems(inputVRItemsCopy);
            }
            
            if (info.files) {
                let inputManualItemsCopy = [];
                nextID.current = 1;
                for (var j=0;j<info.files.length;j++) {
                    const input = {	
                        id: nextID.current,
                        file: {},
                        mFile: info.files[j],
                    };
                    inputManualItemsCopy = [...inputManualItemsCopy, input]
                    nextID.current += 1;
                }
                setInputManualItems(inputManualItemsCopy);
            }
        }
        
    },[info]);

    // const manufacturingCompanyRenderRow = (index, arrayName) => (
    // <Table style={{paddingTop:"10px"}} key={index}>
    //     <TableBody style={{height:"auto",paddingTop:"4px"}}>
    //         <TableRow>
    //         <TableCell>
    //             <Controller
    //                 sx={{ m: 1, minWidth: "90%" }}
    //                 aria-invalid={!isDirty ? undefined : errors.manufacturingCompanyYn?.[index] ? "true" : "false"}
    //                 control={control}
    //                 name={`manufacturingCompanyYn.${index}`}
    //                 render={({ field: {name} }) => (
    //                 <CustomFormSelect
    //                     style={{ minWidth: '90%' }}
    //                     label={t('message.common.subtitle.company.name')}
    //                     register={register}
    //                     name={name}
    //                     requiredMessage={t('message.common.error.text.select')}
    //                     defaultValue={0}
    //                     list={useSelects}
    //                 />
    //                 )}
    //             />
    //             {errors.manufacturingCompanyYn?.[index] && <small role="alert"><br></br>{errors.manufacturingCompanyYn?.[index].message}</small>}
    //         </TableCell>
    //         <TableCell className="th" align="center">{t('message.common.subtitle.company.name')}</TableCell>
    //         <TableCell colSpan={2}>
    //             <Controller
    //                 sx={{ m: 1, minWidth: "90%" }}
    //                 aria-invalid={!isDirty ? undefined : errors.manufacturingCompanyId?.[index] ? "true" : "false"}
    //                 control={control}
    //                 name={`manufacturingCompanyId.${index}`}
    //                 rules={{
    //                     validate: (value, formValues) => {
    //                         if (formValues['manufacturingCompanyYn'][index] === 1 &&
    //                             !value) {
    //                                 console.log(2222)
    //                             return t('message.common.error.text.company.select');
    //                         }
    //                         return true;
    //                     }
    //                 }}
    //                 render={({ field: {name} }) => (
    //                 <CustomFormSelect
    //                     style={{ minWidth: '90%' }}
    //                     label={t('message.common.subtitle.company.name')}
    //                     register={register}
    //                     name={name}
    //                     // requiredMessage={t('message.common.error.text.liftControlPanel.select')}
    //                     defaultValue={info.manufacturingCompany?.id || ''}
    //                     list={companies.filter((comp)=>comp.type === 'MF')}
    //                 />
    //                 )}
    //             />
    //             {errors.manufacturingCompanyId?.[index] && <small role="alert"><br></br>{errors.manufacturingCompanyId?.[index].message}</small>}
    //         </TableCell>
    //         </TableRow>
    //     </TableBody>
    // </Table>
    // )

    // const maintenanceCompanyRenderRow = (index, arrayName) => (
    // <Table style={{paddingTop:"10px"}} key={index}>
    //     <TableBody style={{height:"auto",paddingTop:"4px"}}>
    //     <TableRow>
    //         <TableCell>
    //             <Controller
    //                 sx={{ m: 1, minWidth: "90%" }}
    //                 aria-invalid={!isDirty ? undefined : errors.maintenanceCompanyYn?.[index] ? "true" : "false"}
    //                 control={control}
    //                 name={`maintenanceCompanyYn.${index}`}
    //                 render={({ field: {name} }) => (
    //                 <CustomFormSelect
    //                     style={{ minWidth: '90%' }}
    //                     label={t('message.common.subtitle.company.name')}
    //                     register={register}
    //                     name={name}
    //                     defaultValue={0}
    //                     requiredMessage={t('message.common.error.text.select')}
    //                     list={useSelects}
    //                 />
    //                 )}
    //             />
    //             {errors.maintenanceCompanyYn?.[index] && <small role="alert"><br></br>{errors.maintenanceCompanyYn?.[index].message}</small>}
    //         </TableCell>
    //         <TableCell className="th" align="center">{t('message.common.subtitle.company.name')}</TableCell>
    //         <TableCell colSpan={2}>
    //             <Controller
    //                 sx={{ m: 1, minWidth: "90%" }}
    //                 aria-invalid={!isDirty ? undefined : errors.maintenanceCompanyId?.[index] ? "true" : "false"}
    //                 control={control}
    //                 name={`maintenanceCompanyId.${index}`}
    //                 rules={{
    //                     validate: (value, formValues) => {
    //                         if (formValues['maintenanceCompanyYn'][index] === 1 &&
    //                             !value) {
    //                             return t('message.common.error.text.company.select');
    //                         }
    //                         return true;
    //                     }
    //                 }}
    //                 render={({ field: {name} }) => (
    //                 <CustomFormSelect
    //                     style={{ minWidth: '90%' }}
    //                     label={t('message.common.subtitle.company.name')}
    //                     register={register}
    //                     name={name}
    //                     // requiredMessage={t('message.common.error.text.liftControlPanel.select')}
    //                     defaultValue={info.maintenanceCompanyId?.id || ''}
    //                     list={companies.filter((comp)=>comp.type === 'MT')}
    //                 />
    //                 )}
    //             />
    //             {errors.maintenanceCompanyId?.[index] && <small role="alert"><br></br>{errors.maintenanceCompanyId?.[index].message}</small>}
    //         </TableCell>
    //     </TableRow>
    //     </TableBody>
    // </Table>
    // )

    function addImageFile(file) {
        const input = {	
            id: nextImgID.current,
            file: {},
            imgFile: file,
        };

        setInputImageItems([...inputImageItems, input]);
        nextImgID.current += 1;
    }

    // 삭제
    function deleteImageFile(index) {
        setInputImageItems(inputImageItems.filter(item => item.id !== index));
    }

    async function handleImageFileChange(e, index) {
        if (index > inputImageItems.length) return;

        const compressedFile = (await resizeFile(e.target.files[0], 640, 480));
        
        let inputItemsCopy = [...inputImageItems];
        inputItemsCopy[index].file = compressedFile;
        inputItemsCopy[index].imgFile = null;

        setInputImageItems(inputItemsCopy);
    }

    function addVRFile(id, file) {
        const input = {	
            id: nextVRID.current,
            file: {},
            vId : id,
            vFile: file,
        };

        setInputVRItems([...inputVRItems, input]);
        nextVRID.current += 1;
    }
    
    // 삭제
    function deleteInputVRFile(index) {
        let inputVRItemsCopy = [...inputVRItems];
        inputVRItemsCopy[index-1].file = null;
        inputVRItemsCopy[index-1].vId = null;
        inputVRItemsCopy[index-1].vFile = null;
        setInputVRItems(inputVRItemsCopy);
    }

    async function handleInputVRFileChange(e, index) {
        if (index > inputVRItems.length) return;

        const compressedFile = (await resizeFile(e.target.files[0], 5000, 3750));
        
        let inputVRItemsCopy = [...inputVRItems];
        inputVRItemsCopy[index].file = compressedFile;
        inputVRItemsCopy[index].vId = null;
        inputVRItemsCopy[index].vFile = null;
        setInputVRItems(inputVRItemsCopy);
    }

    function addManualFile(file) {
        const input = {	
            id: nextID.current,
            file: {},
            mFile: file,
        };

        setInputManualItems([...inputManualItems, input]);
        nextID.current += 1;
    }

    // 삭제
    function deleteManualFile(index) {
        setInputManualItems(inputManualItems.filter(item => item.id !== index));
    }

    function handleManualFileChange(e, index) {
        if (index > inputManualItems.length) return;
        
        let inputItemsCopy = [...inputManualItems];
        inputItemsCopy[index].file = e.target.files[0];
        inputItemsCopy[index].mFile = null;
        setInputManualItems(inputItemsCopy);
    }

    // 기본이미지삭제
    // function deleteImgFile() {
    //     setImgFileId(null);
    // }

    // 도면이미지삭제
    function deleteBpFile() {
        setBpFileId(null);
    }

    // 설비 등록/수정
    const onSubmit = (data, e) => {
        console.log(data)
        e.preventDefault();
        setFileLoading(true);

        const equipmentId = data.id;
        const stationId = 51;
        const equipmentCategoryLevel1Id = data.equipmentCategoryLevel1Id;
        const equipmentCategoryLevel2Id = data.equipmentCategoryLevel2Id;
        const equipmentCategoryLevel3Id = data.equipmentCategoryLevel3Id;
        const equipmentNo = data.equipmentNo;
        const name = data.name;
        const location = data.location;
        const modelName = data.modelName;
        const madeYmd = data.madeYmd;
        const instlYmd = data.instlYmd;
        
        const remark = data.remark;
        const opStatus = data.opStatus;
        const disposalYmd = data.disposalYmd;
console.log(data.managementCompanyId)
        if (data.managementCompanyId === null || data.managementCompanyId === undefined || data.managementCompanyId === '') {
            handleAlertClick(getEnumValueByEnumNameAndCode('CompanyType', 'MAN')?.[0]?.title + ' ' + t('message.common.error.text.company.select'));
            setFileLoading(false);
            return;
        }
        if (data.maintenanceCompanyYn && (data.maintenanceCompanyId === null || data.maintenanceCompanyId === undefined || data.maintenanceCompanyId === '')) {
            handleAlertClick(getEnumValueByEnumNameAndCode('CompanyType', 'MNT')?.[0]?.title + ' ' + t('message.common.error.text.company.select'));
            setFileLoading(false);
            return;
        }

        if (data.manufacturingCompanyYn && (data.manufacturingCompanyId === null || data.manufacturingCompanyId === undefined || data.manufacturingCompanyId === '')) {
            handleAlertClick(getEnumValueByEnumNameAndCode('CompanyType', 'MFR')?.[0]?.title + ' ' + t('message.common.error.text.company.select'));
            setFileLoading(false);
            return;
        }

        if (data.zoneId === null || data.zoneId === undefined || data.zoneId === '') {
            handleAlertClick(t('message.common.error.text.zone.select'));
            setFileLoading(false);
            return;
        }
        
        if (data.madeYmd != null && data.madeYmd != '' && !regexDate.test(data.madeYmd)) {
            handleAlertClick(t('message.common.alert.production.date.input'));
            setFileLoading(false);
            return;
        }

        if (data.instlYmd != null && data.instlYmd != '' && !regexDate.test(data.instlYmd)) {
            handleAlertClick(t('message.common.alert.installation.date.input'));
            setFileLoading(false);
            return;
        }

        if (data.disposalYmd != null && data.disposalYmd != '' && !regexDate.test(data.disposalYmd)) {
            handleAlertClick(t('message.common.alert.disposal.date.input'));
            setFileLoading(false);
            return;
        }

        if (!data.controlPanelId || data.controlPanelId <= 0) {
            handleAlertClick(t('message.common.error.text.liftControlPanel.select'));
            setFileLoading(false);
            return;
        }

        let dto = {
            id: (equipmentId ?? null),
            station : {id : stationId},
            equipmentCtgr: {
                id: equipmentCategoryLevel3Id
            },
            equipmentNo,
            name,
            location,
            modelName,
            madeYmd,
            instlYmd,
            remark,
            opStatus,
            disposalYmd,
        };
// console.log(selectManagementCompany)
// console.log(managementCompany)
// console.log(maintenanceCompany)
// console.log(manufacturingCompany)
// console.log(managementCompanyZone)
// console.log(data.managementCompanyId, typeof data.managementCompanyId);
        if (data.managementCompanyId !== null && data.managementCompanyId !== undefined && data.managementCompanyId !== '' ) {
            // console.log(selectManagementCompany)
            if (selectManagementCompany === 0) {
                dto.managementCompany = managementCompany;
            } else {
                dto.managementCompany = {id : selectManagementCompany}
            }
        }
        if (data.maintenanceCompanyYn && data.maintenanceCompanyId !== null && data.maintenanceCompanyId !== undefined && data.maintenanceCompanyId !== '') {
            // console.log(selectMaintenanceCompany)
            if (selectMaintenanceCompany === 0) {
                dto.maintenanceCompany = maintenanceCompany;
            } else {
                dto.maintenanceCompany = {id : selectMaintenanceCompany}
            }
        }
        if (data.manufacturingCompanyYn && data.manufacturingCompanyId !== null && data.manufacturingCompanyId !== undefined && data.manufacturingCompanyId !== '') {
            // console.log(selectManufacturingCompany)
            if (selectManufacturingCompany === 0) {
                dto.manufacturingCompany = manufacturingCompany;
            } else {
                dto.manufacturingCompany = {id : selectManufacturingCompany}
            }
        }
        if (data.zoneId !== null && data.zoneId !== undefined && data.zoneId !== '') {
            // console.log(selectManagementCompanyZone)
            if (selectManagementCompanyZone === 0) {
                dto.zone = managementCompanyZone;
            } else {
                dto.zone = {id : selectManagementCompanyZone}
            }
        }
        
        // if (equipmentCategoryLevel1Code === 'EV' || equipmentCategoryLevel1Code === 'ES') {
        if (data.controlPanelId > 0) {
            dto.controlPanel = {id : data.controlPanelId};
        }

        // if (selectManagementCompany !== null && selectManagementCompany !== undefined) {
        //     console.log(selectManagementCompany)
        //     if (selectManagementCompany === 0) {
        //         dto.managementCompany = managementCompany;
        //     } else {
        //         dto.managementCompany = {id : selectManagementCompany}
        //     }
        // }

        // if (selectManagementCompany !== null && selectManagementCompany !== undefined) {
        //     console.log(selectManagementCompany)
        //     if (selectManagementCompany === 0) {
        //         console.log(111)
        //         dto.managementCompany = managementCompany;
        //     } else {
        //         console.log(222);
        //         dto.managementCompany = {id : selectManagementCompany}
        //     }
        // }

        let formData = new FormData();
        if(inputImageItems) {
            for (var r=0;r<inputImageItems.length;r++) {
                // console.log(inputImageItems[r].file)
                if (inputImageItems[r].file && inputImageItems[r].file.name) {
                    // console.log(inputImageItems[r].file)
                    formData.append("imgFiles", inputImageItems[r].file);
                }
            }
        }
        formData.append("bpFile", bpFile);
        if(inputVRItems) {
            for (var k=0;k<inputVRItems.length;k++) {
                if (inputVRItems[k].file && inputVRItems[k].file.name) {
                    formData.append("vrFile"+(k+1), inputVRItems[k].file);
                }
            }
        }

        if(inputManualItems) {
            for (var l=0;l<inputManualItems.length;l++) {
                if (inputManualItems[l].file && inputManualItems[l].file.name)
                    formData.append("files", inputManualItems[l].file);
            }
        }

        // console.log(dto)
        try {
            if (equipmentId) {  // 수정
                delete dto.equipmentCtgr;
                // if (!imgFile && (imgFileId && imgFileId !== 0)) {
                //     dto.imgFile = {id : imgFileId};
                // }
                // console.log(inputImageItems)
                // console.log(inputImageItems.length)
                if (inputImageItems) {
                    let imgFiles = [];
                    for (var a1=0;a1<inputImageItems.length;a1++) {
                        if (inputImageItems[a1].imgFile && inputImageItems[a1].imgFile.id)
                            imgFiles.push({id : inputImageItems[a1].imgFile.id});
                    }
                    dto.imgFiles = imgFiles;
                }
                if (!bpFile  && (bpFileId && bpFileId !== 0)) {
                    dto.bpFile = {id : bpFileId};
                }
                if (inputVRItems) {
                    let vFiles = [];
                    for (var a=0;a<inputVRItems.length;a++) {
                        if (inputVRItems[a].vId)
                            vFiles.push({id : inputVRItems[a].vId});
                    }
                    dto.vrFiles = vFiles;
                }

                if (inputManualItems) {
                    let mFiles = [];
                    for (var a2=0;a2<inputManualItems.length;a2++) {
                        if (inputManualItems[a2].mFile && inputManualItems[a2].mFile.id)
                            mFiles.push({id : inputManualItems[a2].mFile.id});
                    }
                    dto.files = mFiles;
                }
                console.log(dto)
                formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );

                openModal(modals.confirmModal, {
                    onSubmit : (value) => {
                        try {
                            const res = customFileAxios.patch(`/api/equipments/${equipmentId}`, formData)
                            .then(async(res)=>{
                                console.log(res)
                                await writeAuditLog({
                                    actionType: "UPDATE",
                                    targetType: "EQUIPMENT",
                                    targetId: equipmentId,
                                    targetName: equipmentNo,

                                    apiUrl : `/api/equipments/${equipmentId}`,
                                    requestMethod : 'PATCH',
                                    // summary: t('message.common.log.memo.equipment.update'),
                                    summary: 'message.common.log.memo.equipment.update',
                                    payload : dto
                                });

                                setFileLoading(false);
                                onRefresh();
                                handleAlertClick(t('message.common.alert.modify.done'));
                            }).catch((err)=>{
                                console.log(err);
                                setFileLoading(false);
                                handleAlertClick(err.response?.data?.message || err.message);
                            });
                            // return res.data;
                        } catch (error) {
                            console.error("error :", error);
                            throw error;
                        }

                    },
                    onClose : () => {
                        setFileLoading(false);
                        console.log('close');
                    },
                    message: t('message.common.alert.modify.question'),
                });
            } else {    // 등록
                console.log(dto)
                formData.append("dto", new Blob([JSON.stringify(dto)], {type: "application/json"}) );
                let vrFileIdxs = [];
                for (var value2 of formData.entries()) {
                    if (value2[0].indexOf('vrFile') !== -1) {
                        vrFileIdxs.push(value2[0].replace('vrFile',''));
                    }
                }

                if (vrFileIdxs.length !== 0 && vrFileIdxs.length !== Math.max.apply(null, vrFileIdxs)) {
                    handleAlertClick(t('message.common.alert.vr.equipment.picture.order.write'));
                    return;
                }

                openModal(modals.confirmModal, {
                    onSubmit : (value) => {
                        try {
                            const res = customFileAxios.post(`/api/equipments`, formData)
                            .then(async(res)=>{
                                console.log(res)
                                await writeAuditLog({
                                    actionType: "CREATE",
                                    targetType: "EQUIPMENT",
                                    targetId: res.data?.id,
                                    targetName: equipmentNo,

                                    apiUrl : `/api/equipments`,
                                    requestMethod : 'POST',
                                    // summary: t('message.common.log.memo.equipment.create'),
                                    summary: 'message.common.log.memo.equipment.create',
                                    payload : dto
                                });

                                setFileLoading(false);
                                onRefresh();
                                //console.log(res);
                                handleAlertClick(t('message.common.alert.write.done'));
                                navigate('../modify/'+res.data.id+window.location.search);
                            }).catch((err)=>{
                                console.log(err);
                                setFileLoading(false);
                                handleAlertClick(err.response?.data?.message || err.message);
                            });
                            // return res.data;
                        } catch (error) {
                            console.error("error :", error);
                            throw error;
                        }
                    },
                    onClose : () => {
                        setFileLoading(false);
                        console.log('close');
                    },
                    message: t('message.common.alert.write.question'),
                });
            }
        } catch(error) {
            console.log(error);
            setFileLoading(false);
        }
    }
    
    const handleDeleteBtnClick = (param) => {
        if (param) {
            openModal(modals.confirmModal, {
            onSubmit : (value) => {
                deleteEquipments(param)
                .then(async(res) => {
                    console.log(res)
                    await writeAuditLog({
                        actionType: "DELETE",
                        targetType: "EQUIPMENT",
                        targetId: info.id,
                        targetName: info.equipmentNo,

                        apiUrl : `/api/equipments/${info.id}`,
                        requestMethod : 'DELETE',
                        // summary: t('message.common.log.memo.equipment.delete'),
                        summary: 'message.common.log.memo.equipment.delete',
                        payload : null
                    });

                    navigate('../../'+window.location.search);
                }).catch((err)=>{
                    console.log(err);
                    handleAlertClick(err.response?.data?.message || err.message);
                });
            },
            onClose : () => {
                console.log('close');
            },
            message: t('message.common.alert.delete.question'),
            });
        }
    }

    const equipmentNoSearch = () => {
        let param = {
            "equipmentCtgr.parent.parent.id" : equipmentCategoryLevel1Id,
            "equipmentCtgr.parent.id" : equipmentCategoryLevel2Id,
            "equipmentCtgr.id" : equipmentCategoryLevel3Id,
        };
        
        if (equipmentCategoryLevel1Id === null || equipmentCategoryLevel1Id === '') {
            handleAlertClick(t('message.common.alert.level1.select'));
            return;
        }
        if (equipmentCategoryLevel2Id === null || equipmentCategoryLevel2Id === '') {
            handleAlertClick(t('message.common.alert.level2.select'));
            return;
        }
        if (equipmentCategoryLevel3Id === null || equipmentCategoryLevel3Id === '') {
            handleAlertClick(t('message.common.alert.level3.select'));
            return;
        }
        getEquipmentsByQuery(param).then((data)=>{
            if (data?._embedded?.equipments != null) {
                setEquipmentNoList(data?._embedded?.equipments);
            } else {
                setEquipmentNoList([]);
            }
        })
    }

    if (info) { // 수정
        return (
        <>
            <MainCard className="equipment_add" style={{marginTop:"10px"}}>
                <div style={{marginBottom:"10px"}}>
                    <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                    <Chip label={t('message.common.chip.equipment.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <TableContainer style={{width:"100%"}}>
                        <Table sx={{ minWidth: 400, borderTop: "2px solid #a2a2a2", "& .MuiTableCell-root": { py: 1.9 } }} aria-label="simple table">
                            <TableBody style={{height:"auto"}}>
                                {platformServer === 'NANTONG' ? <input type="hidden" {...register('managementCompanyId')} value={nantongCompanyId} />
                                :
                                <TableRow>
                                    <TableCell className="th" align="center">{getEnumValueByEnumNameAndCode('CompanyType', 'MAN')?.[0]?.title}</TableCell>
                                    <TableCell>
                                        {t('message.common.subtitle.essential')}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.company.name')}</TableCell>
                                    <TableCell colSpan={2}>
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.managementCompanyId ? "true" : "false"}
                                            control={control}
                                            name="managementCompanyId"
                                            defaultValue={info.managementCompany?.id || ''}
                                            render={({ field }) => (
                                            <CustomFormEquipmentSelect
                                                {...field} // value, onChange, name 등을 전달
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.company.name')}
                                                register={register}
                                                // name={name}
                                                requiredMessage={t('message.common.error.text.company.select')}
                                                // defaultValue={info.managementCompany?.id || ''}
                                                onChangeProp={(e)=>{
                                                    // const newValue = Number(e.target.value);
                                                    // field.onChange(newValue);
                                                    setSelectManagementCompany(e.target.value)
                                                }}
                                                list={manageCompanies}
                                            />
                                            )}
                                        />
                                        {errors.managementCompanyId && <small role="alert"><br></br>{errors.managementCompanyId.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">
                                        <CompanyWriteLayer setIsCompanyLoading={setIsCompanyLoading} addCompany={managementCompany} setAddCompany={setAddCompany} companyTypeParam='MAN' />
                                    </TableCell>
                                </TableRow>
                                }
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {getEnumValueByEnumNameAndCode('CompanyType', 'MFR')?.[0]?.title}
                                        {/* <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}}
                                        onClick={() => manufacturingCompanyArray.append({ required: t('message.common.subtitle.empty'), company: "" })}
                                         >+</AddCircleOutlineIcon> */}
                                    </TableCell>
                                    <TableCell colSpan={4}>
                                        <Table style={{paddingTop:"10px"}} >
                                            <TableBody style={{height:"auto",paddingTop:"4px"}}>
                                                <TableRow>
                                                {/* <TableCell className="th" align="center">제조사</TableCell> */}
                                                <TableCell>
                                                    <Controller
                                                        sx={{ m: 1, minWidth: "90%" }}
                                                        aria-invalid={!isDirty ? undefined : errors.manufacturingCompanyYn ? "true" : "false"}
                                                        control={control}
                                                        name={`manufacturingCompanyYn`}
                                                        defaultValue={info.manufacturingCompany?.id ? 1 : 0}
                                                        render={({ field }) => (
                                                        <CustomFormEquipmentSelect
                                                            {...field} // value, onChange, name 등을 전달
                                                            style={{ minWidth: '90%' }}
                                                            label={t('message.common.subtitle.company.name')}
                                                            register={register}
                                                            // name={name}
                                                            requiredMessage={t('message.common.error.text.select')}
                                                            list={useSelects}
                                                        />
                                                        )}
                                                    />
                                                    {errors.manufacturingCompanyYn && <small role="alert"><br></br>{errors.manufacturingCompanyYn.message}</small>}
                                                </TableCell>
                                                <TableCell className="th" align="center">{t('message.common.subtitle.company.name')}</TableCell>
                                                <TableCell colSpan={2}>
                                                    <Controller
                                                        sx={{ m: 1, minWidth: "90%" }}
                                                        aria-invalid={!isDirty ? undefined : errors.manufacturingCompanyId ? "true" : "false"}
                                                        control={control}
                                                        name={`manufacturingCompanyId`}
                                                        defaultValue={info.manufacturingCompany?.id || ''}
                                                        rules={{
                                                            validate: (value, formValues) => {
                                                                console.log(value)
                                                                if (formValues['manufacturingCompanyYn'] === 1 &&
                                                                    (value === null || value === undefined || value === '')) {
                                                                    return t('message.common.error.text.company.select');
                                                                }
                                                                return true;
                                                            }
                                                        }}
                                                        render={({ field }) => (
                                                        <CustomFormEquipmentSelect
                                                            {...field} // value, onChange, name 등을 전달
                                                            style={{ minWidth: '90%' }}
                                                            label={t('message.common.subtitle.company.name')}
                                                            register={register}
                                                            onChangeProp={(e)=>{setSelectManufacturingCompany(e.target.value)}}
                                                            // name={name}
                                                            // requiredMessage={t('message.common.error.text.liftControlPanel.select')}
                                                            list={manufacturingCompanies}
                                                        />
                                                        )}
                                                    />
                                                    {errors.manufacturingCompanyId && <small role="alert"><br></br>{errors.manufacturingCompanyId.message}</small>}
                                                </TableCell>
                                                
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                        {/* {manufacturingCompanyArray.fields.map((field, index) =>
                                            manufacturingCompanyRenderRow(index, "manufacturingCompanyArray")
                                        )} */}
                                    </TableCell>
                                    <TableCell className="th" align="center">
                                        <CompanyWriteLayer setIsCompanyLoading={setIsCompanyLoading} addCompany={manufacturingCompany} setAddCompany={setAddCompany} companyTypeParam='MFR' />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {getEnumValueByEnumNameAndCode('CompanyType', 'MNT')?.[0]?.title}
                                        {/* <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}}
                                        onClick={() => maintenanceCompanyArray.append({ required: t('message.common.subtitle.empty'), company: "" })}
                                         >+</AddCircleOutlineIcon> */}
                                    </TableCell>
                                    <TableCell colSpan={4}>
                                        <Table style={{paddingTop:"10px"}}>
                                            <TableBody style={{height:"auto",paddingTop:"4px"}}>
                                            <TableRow>
                                                <TableCell>
                                                    <Controller
                                                        sx={{ m: 1, minWidth: "90%" }}
                                                        aria-invalid={!isDirty ? undefined : errors.maintenanceCompanyYn ? "true" : "false"}
                                                        control={control}
                                                        name={`maintenanceCompanyYn`}
                                                        defaultValue={info.maintenanceCompany?.id ? 1 : 0}
                                                        render={({ field }) => (
                                                        <CustomFormEquipmentSelect
                                                            {...field} // value, onChange, name 등을 전달
                                                            style={{ minWidth: '90%' }}
                                                            label={t('message.common.subtitle.company.name')}
                                                            register={register}
                                                            // name={name}
                                                            requiredMessage={t('message.common.error.text.select')}
                                                            list={useSelects}
                                                        />
                                                        )}
                                                    />
                                                    {errors.maintenanceCompanyYn && <small role="alert"><br></br>{errors.maintenanceCompanyYn.message}</small>}
                                                </TableCell>
                                                <TableCell className="th" align="center">{t('message.common.subtitle.company.name')}</TableCell>
                                                <TableCell colSpan={2}>
                                                    <Controller
                                                        sx={{ m: 1, minWidth: "90%" }}
                                                        aria-invalid={!isDirty ? undefined : errors.maintenanceCompanyId ? "true" : "false"}
                                                        control={control}
                                                        name={`maintenanceCompanyId`}
                                                        defaultValue={info.maintenanceCompany?.id || ''}
                                                        rules={{
                                                            validate: (value, formValues) => {
                                                                if (formValues['maintenanceCompanyYn'] === 1 &&
                                                                    (value === null || value === undefined || value === '')) {
                                                                    return t('message.common.error.text.company.select');
                                                                }
                                                                return true;
                                                            }
                                                        }}
                                                        render={({ field }) => (
                                                        <CustomFormEquipmentSelect
                                                            {...field} // value, onChange, name 등을 전달
                                                            style={{ minWidth: '90%' }}
                                                            label={t('message.common.subtitle.company.name')}
                                                            register={register}
                                                            onChangeProp={(e)=>{setSelectMaintenanceCompany(e.target.value);}}
                                                            // name={name}
                                                            // requiredMessage={t('message.common.error.text.liftControlPanel.select')}
                                                            list={maintenanceCompanies}
                                                        />
                                                        )}
                                                    />
                                                    {errors.maintenanceCompanyId && <small role="alert"><br></br>{errors.maintenanceCompanyId.message}</small>}
                                                </TableCell>
                                            </TableRow>
                                            </TableBody>
                                        </Table>
                                        {/* {maintenanceCompanyArray.fields.map((field, index) =>
                                            maintenanceCompanyRenderRow(index, "maintenanceCompanyArray")
                                        )} */}
                                    </TableCell>
                                    <TableCell className="th" align="center">
                                        <CompanyWriteLayer setIsCompanyLoading={setIsCompanyLoading} addCompany={maintenanceCompany} setAddCompany={setAddCompany} companyTypeParam='MNT' />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    
                    <TableContainer style={{width:"100%"}}>
                        <Table sx={{ minWidth: 400 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2"}}>
                            <TableBody style={{height:"auto"}}>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level1')}</TableCell>
                                    <TableCell>
                                        <input type="hidden" {...register("id")} value={info && (info.id || '')} />
                                        {info.equipmentCtgr && info.equipmentCtgr.parent && info.equipmentCtgr.parent.parent && (info.equipmentCtgr.parent.parent.name || '')}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}</TableCell>
                                    <TableCell>
                                        {info.equipmentCtgr && info.equipmentCtgr.parent && (info.equipmentCtgr.parent.name || '')}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}</TableCell>
                                    <TableCell>
                                        {info.equipmentCtgr && (info.equipmentCtgr.name || '')}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.name')}</TableCell>
                                    <TableCell colSpan={3} className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.name ? "true" : "false"}
                                            defaultValue={info.name || ''}
                                            {...register("name", {
                                                required : t('message.common.alert.equipment.name.input')
                                            })} 
                                            sx={{ minWidth: '90%', backgroundColor: "#fff" }} />
                                        {errors.name && <small role="alert"><br></br>{errors.name.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.number')}</TableCell>
                                    <TableCell className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.equipmentNo ? "true" : "false"}
                                            defaultValue={info.equipmentNo || ''}
                                            {...register("equipmentNo", {
                                                required : t('message.common.error.text.equipment.number.input')
                                            })} 
                                            sx={{ minWidth: '60%' , backgroundColor: "#fff"}} />
                                        {errors.equipmentNo && <small role="alert"><br></br>{errors.equipmentNo.message}</small>}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.modelName')}</TableCell>
                                    <TableCell className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.modelName ? "true" : "false"}
                                            defaultValue={info.modelName || ''}
                                            {...register("modelName", {
                                                required : t('message.common.error.text.modelName.input')
                                            })} 
                                            sx={{ minWidth: '60%', backgroundColor: "#fff" }} />
                                        {errors.modelName && <small role="alert"><br></br>{errors.modelName.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.installation.location')}</TableCell>
                                    <TableCell colSpan={3} className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.location ? "true" : "false"}
                                            defaultValue={info.location || ''}
                                            {...register("location", {
                                                required : t('message.common.error.text.installation.location.input')
                                            })} 
                                            sx={{ minWidth: '90%', backgroundColor: "#fff" }} />
                                        {errors.location && <small role="alert"><br></br>{errors.location.message}</small>}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.madeYmd')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="madeYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker
                                                // defaultValue={info.madeYmd || null}
                                                field={field} ref={ref} name={name} value={toServerDateOnly(info.madeYmd)} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.installation.date')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="instlYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker 
                                                // defaultValue={info.instlYmd || null}
                                                field={field} ref={ref} name={name} value={toServerDateOnly(info.instlYmd)} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.disposal.date')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="disposalYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker 
                                                // defaultValue={info.disposalYmd || null}
                                                field={field} ref={ref} name={name} value={toServerDateOnly(info.disposalYmd)} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                </TableRow>
                                {/* {(info.equipmentCtgr.parent.parent.code === 'EV' || info.equipmentCtgr.parent.parent.code === 'ES') && */}
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.panel')}</TableCell>
                                    <TableCell className="email_pl">
                                        {liftControlPanels &&
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.controlPanelId ? "true" : "false"}
                                            control={control}
                                            name="controlPanelId"
                                            defaultValue={info.controlPanel?.id || '0'}
                                            render={({ field }) => (
                                            <CustomFormEquipmentSelect
                                                {...field} // value, onChange, name 등을 전달
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.panel')}
                                                register={register}
                                                // name={name}
                                                requiredMessage={t('message.common.error.text.liftControlPanel.select')}
                                                list={liftControlPanels}
                                            />
                                            )}
                                        />
                                        }
                                        {errors.controlPanelId && <small role="alert"><br></br>{errors.controlPanelId.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.zone')}</TableCell>
                                    <TableCell className="email_pl" colSpan={3}>
                                        {zones &&
                                        <Controller
                                            // sx={{ m: 1, minWidth: "70%" }}
                                            aria-invalid={!isDirty ? undefined : errors.zoneId ? "true" : "false"}
                                            control={control}
                                            name="zoneId"
                                            defaultValue={info.zone?.id || ''}
                                            render={({ field }) => (
                                            <CustomFormEquipmentSelect
                                                {...field} // value, onChange, name 등을 전달
                                                style={{ minWidth: '70%' }}
                                                label={t('message.common.subtitle.zone')}
                                                register={register}
                                                // name={name}
                                                requiredMessage={t('message.common.error.text.zone.select')}
                                                onChangeProp={(e)=>{setSelectManagementCompanyZone(e.target.value)}}
                                                onOpen={(e)=>{
                                                    console.log(selectManagementCompany)
                                                    if (selectManagementCompany === null || selectManagementCompany === undefined) handleAlertClick(t('message.common.alert.management.company.select'))
                                                }}
                                                list={zones}
                                            />
                                            )}
                                        />
                                        }
                                        {platformServer !== 'NANTONG' && <>&nbsp;&nbsp;<ManagementCompanyZoneWriteLayer managementCompany={selectManagementCompany} managementCompanyZone={managementCompanyZone} setManagementCompanyZone={setManagementCompanyZone} /></>}
                                        {errors.zoneId && <small role="alert"><br></br>{errors.zoneId.message}</small>}
                                    </TableCell>
                                </TableRow>
                                {/* } */}
                                {/* <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.picture.basic')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                    <div style={{display:"flex", justifyContent: "space-between"}}>
                                        <div style={{display:"flex"}}>
                                            <input
                                                type="file" 
                                                accept="image/*" 
                                                onChange={(e)=>{
                                                    fileChangedHandler(e, 640, 480, setImgFile);
                                                    setImgFileId(null);
                                                }}
                                            />
                                            {imgFileId && 
                                                <>
                                                    <FileDownloadIcon file={info.imgFile} viewFileName={true} fontColor="#000" />
                                                    <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteImgFile()}>-</RemoveCircleOutlineIcon>
                                                </>
                                            }
                                        </div>
                                        <div style={{color:"red",fontWeight:"bold"}}>*{t('message.common.text.horizontal.picture.recommend')}</div>
                                    </div>
                                    </TableCell>
                                </TableRow> */}
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.equipment.picture.basic')}
                                        {inputImageItems?.length < 4 && <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addImageFile}>+</AddCircleOutlineIcon>}
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputImageItems && inputImageItems.map(function(item, index) {
                                        return (
                                        <div key={index} style={{display:"flex"}}>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                value={''}
                                                onChange={e => {
                                                    handleImageFileChange(e, index);
                                                }}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : (item.imgFile && item.imgFile.id && <><FileDownloadIcon file={item.imgFile} viewFileName={true} fontColor="#000" /></>)}
                                            { inputImageItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteImageFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        )
                                        })}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.picture.drawing')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        <div style={{display:"flex"}}>
                                            <input 
                                                type="file" 
                                                accept="image/*" 
                                                onChange={(e)=>{
                                                    fileChangedHandler(e, 1920, 1920, setBpFile)
                                                    setBpFileId(null);
                                                }}
                                            />
                                            {bpFileId && 
                                                <>
                                                    <FileDownloadIcon file={info.bpFile} viewFileName={true} fontColor="#000" />
                                                    <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteBpFile()}>-</RemoveCircleOutlineIcon>
                                                </>
                                            }
                                        </div>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.equipment.picture.vr')}
                                        {inputVRItems.length < 8 && (
                                            <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addVRFile}>+</AddCircleOutlineIcon>
                                        )}
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputVRItems.map((item, index) => (
                                        <div key={index} style={{display:"flex", padding: "4px 5px"}}>
                                            <span style={{width:"20px", textAlign:"center", padding:"3px"}}>{(index+1)}. </span>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                value={''}
                                                onChange={e => {
                                                    handleInputVRFileChange(e, index);
                                                }}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : <>{(item.vFile && item.vFile.id && <FileDownloadIcon file={item.vFile} viewFileName={true} fontColor="#000" />)}</>}
                                            { inputVRItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputVRFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        ))}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.manual.data')}
                                        <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addManualFile}>+</AddCircleOutlineIcon>
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputManualItems && inputManualItems.map(function(item, index) {
                                        return (
                                        <div key={index} style={{display:"flex"}}>
                                            <input
                                                type="file"
                                                value={''}
                                                onChange={e => {
                                                    handleManualFileChange(e, index);
                                                }}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : (item.mFile && item.mFile.id && <><FileDownloadIcon file={item.mFile} viewFileName={true} fontColor="#000" /></>)}
                                            { inputManualItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteManualFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        )
                                        })}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.remark')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.remark ? "true" : "false"}
                                            defaultValue={info.remark || ''}
                                            {...register("remark", {
                                            })} 
                                            multiline
                                            rows={3}
                                            sx={{ minWidth: '90%', backgroundColor: "#fff", marginTop: "10px" }} />
                                        <div style={{color:"red",fontWeight:"bold",textAlign:"left"}}>* [{t('message.common.title.comprehensive.report.8.maintenance.main.communication.reflected')}]</div>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.opStatus')}</TableCell>
                                    <TableCell className="email_pl">
                                        {(info && info.opStatus && getEnumValueByEnumName("EquipmentOpStatus")) &&
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.opStatus ? "true" : "false"}
                                            control={control}
                                            name="opStatus"
                                            render={({ field: {name} }) => (
                                            <CustomFormEnumSelect
                                                key={'opStatus'}
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.opStatus')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.operating.state.select')}
                                                defaultValue={info && (info.opStatus || '')}
                                                list={getEnumValueByEnumName("EquipmentOpStatus")}
                                            />
                                            )}
                                        />
                                        }
                                        {errors.opStatus && <small role="alert"><br></br>{errors.opStatus.message}</small>}
                                    </TableCell>
                                    <TableCell colSpan={4}>&nbsp;
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </form>
            </MainCard>

            <div className="btn_right" style={{margin:"8px"}}>
                <LoadingButton variant="contained" color="success" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.modify')}</LoadingButton>&nbsp;&nbsp;
                <Button variant="contained" color="error" onClick={()=>{handleDeleteBtnClick(info.id)}}>{t('message.common.btn.delete')}</Button>
            </div>
        </>
        )
        //}
    } else {    // 등록
        return (
        <>
            <MainCard className="equipment_add" style={{marginTop:"10px"}}>
                <div style={{marginBottom:"10px"}}>
                    <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                    <Chip label={t('message.common.chip.equipment.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <TableContainer style={{ width: "100%" }}>
                        <Table sx={{ minWidth: 400 }} aria-label="simple table" style={{ borderTop: "2px solid #a2a2a2" }}>
                            <TableBody style={{height:"auto"}}>
                                {platformServer === 'NANTONG' ? <input type="hidden"  {...register('managementCompanyId')} value={nantongCompanyId} />
                                :
                                <TableRow>
                                    <TableCell className="th" align="center">{getEnumValueByEnumNameAndCode('CompanyType', 'MAN')?.[0]?.title}</TableCell>
                                    <TableCell>
                                        {t('message.common.subtitle.essential')}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.company.name')}</TableCell>
                                    <TableCell colSpan={2}>
                                        <Controller
                                            // key={'managementCompanyId'}
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.managementCompanyId ? "true" : "false"}
                                            control={control}
                                            name="managementCompanyId"
                                            defaultValue={selectManagementCompany ?? ''}
                                            render={({ field }) => (
                                            <CustomFormEquipmentSelect
                                                // key={'managementCompanyId'}
                                                {...field} // value, onChange, name 등을 전달
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.company.name')}
                                                register={register}
                                                // name={name}
                                                requiredMessage={t('message.common.error.text.company.select')}
                                                onChangeProp={(e)=>{
                                                    // console.log(e)
                                                    setSelectManagementCompany(e.target.value)
                                                }}
                                                list={manageCompanies}
                                                // renderValue={v => console.log(`현재: ${v}`)}
                                            />
                                            )}
                                        />
                                        {errors.managementCompanyId && <small role="alert"><br></br>{errors.managementCompanyId.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">
                                        <CompanyWriteLayer setIsCompanyLoading={setIsCompanyLoading} addCompany={managementCompany} setAddCompany={setAddCompany} companyTypeParam='MAN' />
                                    </TableCell>
                                </TableRow>
                                }
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {getEnumValueByEnumName('CompanyType')?.filter(cType=>cType.code === 'MFR')?.[0]?.title}
                                        {/* <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}}
                                        onClick={() => manufacturingCompanyArray.append({ required: t('message.common.subtitle.empty'), company: "" })}
                                         >+</AddCircleOutlineIcon> */}
                                    </TableCell>
                                    <TableCell colSpan={4}>
                                        <Table style={{paddingTop:"10px"}} >
                                            <TableBody style={{height:"auto",paddingTop:"4px"}}>
                                                <TableRow>
                                                {/* <TableCell className="th" align="center">제조사</TableCell> */}
                                                <TableCell>
                                                    <Controller
                                                        sx={{ m: 1, minWidth: "90%" }}
                                                        aria-invalid={!isDirty ? undefined : errors.manufacturingCompanyYn ? "true" : "false"}
                                                        control={control}
                                                        name={`manufacturingCompanyYn`}
                                                        defaultValue={0}
                                                        render={({ field }) => (
                                                        <CustomFormEquipmentSelect
                                                            {...field}
                                                            style={{ minWidth: '90%' }}
                                                            label={t('message.common.subtitle.company.name')}
                                                            register={register}
                                                            // name={name}
                                                            requiredMessage={t('message.common.error.text.select')}
                                                            list={useSelects}
                                                        />
                                                        )}
                                                    />
                                                    {errors.manufacturingCompanyYn && <small role="alert"><br></br>{errors.manufacturingCompanyYn.message}</small>}
                                                </TableCell>
                                                <TableCell className="th" align="center">{t('message.common.subtitle.company.name')}</TableCell>
                                                <TableCell colSpan={2}>
                                                    <Controller
                                                        sx={{ m: 1, minWidth: "90%" }}
                                                        aria-invalid={!isDirty ? undefined : errors.manufacturingCompanyId ? "true" : "false"}
                                                        control={control}
                                                        name={`manufacturingCompanyId`}
                                                        defaultValue={selectManufacturingCompany ?? ''} // Controller의 defaultValue 지정
                                                        rules={{
                                                            validate: (value, formValues) => {
                                                                console.log(value)
                                                                if (formValues['manufacturingCompanyYn'] === 1 &&
                                                                    (value === null || value === undefined || value === '')) {
                                                                    return t('message.common.error.text.company.select');
                                                                }
                                                                return true;
                                                            }
                                                        }}
                                                        render={({ field }) => (
                                                        <CustomFormEquipmentSelect
                                                            {...field} // value, onChange, name 등을 전달
                                                            style={{ minWidth: '90%' }}
                                                            label={t('message.common.subtitle.company.name')}
                                                            register={register}
                                                            onChangeProp={(e)=>{setSelectManufacturingCompany(e.target.value)}}
                                                            // name={name}
                                                            // requiredMessage={t('message.common.error.text.liftControlPanel.select')}
                                                            list={manufacturingCompanies}
                                                        />
                                                        )}
                                                    />
                                                    {errors.manufacturingCompanyId && <small role="alert"><br></br>{errors.manufacturingCompanyId.message}</small>}
                                                </TableCell>
                                                
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                        {/* {manufacturingCompanyArray.fields.map((field, index) =>
                                            manufacturingCompanyRenderRow(index, "manufacturingCompanyArray")
                                        )} */}
                                    </TableCell>
                                    <TableCell className="th" align="center">
                                        <CompanyWriteLayer setIsCompanyLoading={setIsCompanyLoading} addCompany={manufacturingCompany} setAddCompany={setAddCompany} companyTypeParam='MFR' />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {getEnumValueByEnumName('CompanyType')?.filter(cType=>cType.code === 'MNT')?.[0]?.title}
                                        {/* <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}}
                                        onClick={() => maintenanceCompanyArray.append({ required: t('message.common.subtitle.empty'), company: "" })}
                                         >+</AddCircleOutlineIcon> */}
                                    </TableCell>
                                    <TableCell colSpan={4}>
                                        <Table style={{paddingTop:"10px"}}>
                                            <TableBody style={{height:"auto",paddingTop:"4px"}}>
                                            <TableRow>
                                                <TableCell>
                                                    <Controller
                                                        sx={{ m: 1, minWidth: "90%" }}
                                                        aria-invalid={!isDirty ? undefined : errors.maintenanceCompanyYn ? "true" : "false"}
                                                        control={control}
                                                        name={`maintenanceCompanyYn`}
                                                        defaultValue={0}
                                                        render={({ field }) => (
                                                        <CustomFormEquipmentSelect
                                                            {...field} // value, onChange, name 등을 전달
                                                            style={{ minWidth: '90%' }}
                                                            label={t('message.common.subtitle.company.name')}
                                                            register={register}
                                                            // name={name}
                                                            requiredMessage={t('message.common.error.text.select')}
                                                            list={useSelects}
                                                        />
                                                        )}
                                                    />
                                                    {errors.maintenanceCompanyYn && <small role="alert"><br></br>{errors.maintenanceCompanyYn.message}</small>}
                                                </TableCell>
                                                <TableCell className="th" align="center">{t('message.common.subtitle.company.name')}</TableCell>
                                                <TableCell colSpan={2}>
                                                    <Controller
                                                        sx={{ m: 1, minWidth: "90%" }}
                                                        aria-invalid={!isDirty ? undefined : errors.maintenanceCompanyId ? "true" : "false"}
                                                        control={control}
                                                        name={`maintenanceCompanyId`}
                                                        defaultValue={selectMaintenanceCompany || ''}
                                                        rules={{
                                                            validate: (value, formValues) => {
                                                                if (formValues['maintenanceCompanyYn'] === 1 &&
                                                                    (value === null || value === undefined || value === '')) {
                                                                    return t('message.common.error.text.company.select');
                                                                }
                                                                return true;
                                                            }
                                                        }}
                                                        render={({ field }) => (
                                                        <CustomFormEquipmentSelect
                                                            {...field} // value, onChange, name 등을 전달
                                                            style={{ minWidth: '90%' }}
                                                            label={t('message.common.subtitle.company.name')}
                                                            register={register}
                                                            onChangeProp={(e)=>{setSelectMaintenanceCompany(e.target.value)}}
                                                            // name={name}
                                                            // requiredMessage={t('message.common.error.text.liftControlPanel.select')}
                                                            list={maintenanceCompanies}
                                                        />
                                                        )}
                                                    />
                                                    {errors.maintenanceCompanyId && <small role="alert"><br></br>{errors.maintenanceCompanyId.message}</small>}
                                                </TableCell>
                                            </TableRow>
                                            </TableBody>
                                        </Table>
                                        {/* {maintenanceCompanyArray.fields.map((field, index) =>
                                            maintenanceCompanyRenderRow(index, "maintenanceCompanyArray")
                                        )} */}
                                    </TableCell>
                                    <TableCell className="th" align="center">
                                        <CompanyWriteLayer setIsCompanyLoading={setIsCompanyLoading} addCompany={maintenanceCompany} setAddCompany={setAddCompany} companyTypeParam='MNT' />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    
                    <TableContainer style={{width:"100%"}}>
                        <Table sx={{ minWidth: 400 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2"}}>
                            <TableBody style={{height:"auto"}}>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level1')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.equipmentCategoryLevel1Id ? "true" : "false"}
                                            control={control}
                                            name="equipmentCategoryLevel1Id"
                                            defaultValue={''}
                                            render={({ field }) => (
                                            <CustomFormEquipmentSelect
                                                {...field} // value, onChange, name 등을 전달
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.equipment.level1')}
                                                register={register}
                                                // name={name}
                                                requiredMessage={t('message.common.error.text.level1.select')}
                                                onChangeProp={(e)=>{
                                                    console.log(e)
                                                    const val = e.target.value;
                                                    setEquipmentCategoryLevel1Id(val)
                                                    // setEquipmentCategoryLevel1Id(val.split(",")[0]);
                                                    // setEquipmentCategoryLevel1Code(val.split(",")[1]);
                                                }}
                                                list={level1s}
                                            />
                                            )}
                                        />
                                        {errors.equipmentCategoryLevel1Id && <small role="alert"><br></br>{errors.equipmentCategoryLevel1Id.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level2')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.equipmentCategoryLevel2Id ? "true" : "false"}
                                            control={control}
                                            name="equipmentCategoryLevel2Id"
                                            defaultValue={''}
                                            render={({ field }) => (
                                            <CustomFormEquipmentSelect
                                                {...field} // value, onChange, name 등을 전달
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.equipment.level2')}
                                                register={register}
                                                // name={name}
                                                requiredMessage={t('message.common.error.text.level2.select')}
                                                onChangeProp={(e)=>{
                                                    setEquipmentCategoryLevel2Id(e.target.value);
                                                }}
                                                list={equipmentCategoryLevel2s}
                                            />
                                            )}
                                        />
                                        {errors.equipmentCategoryLevel2Id && <small role="alert"><br></br>{errors.equipmentCategoryLevel2Id.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.level3')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.equipmentCategoryLevel3Id ? "true" : "false"}
                                            control={control}
                                            name="equipmentCategoryLevel3Id"
                                            defaultValue={''}
                                            render={({ field }) => (
                                            <CustomFormEquipmentSelect
                                                {...field} // value, onChange, name 등을 전달
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.equipment.level3')}
                                                register={register}
                                                // name={name}
                                                requiredMessage={t('message.common.alert.level3.select')}
                                                onChangeProp={(e)=>{
                                                    setEquipmentCategoryLevel3Id(e.target.value);
                                                }}
                                                list={equipmentCategoryLevel3s}
                                            />
                                            )}
                                        />
                                        {errors.equipmentCategoryLevel3Id && <small role="alert"><br></br>{errors.equipmentCategoryLevel3Id.message}</small>}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.name')}</TableCell>
                                    <TableCell colSpan={3} className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.name ? "true" : "false"}
                                            {...register("name", {
                                                required : t('message.common.alert.equipment.name.input')
                                            })} 
                                            sx={{ minWidth: '90%', backgroundColor: "#fff" }} />
                                        {errors.name && <small role="alert"><br></br>{errors.name.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.equipment.number')} &nbsp;
                                        <Button variant="contained" color="primary" onClick={()=>{equipmentNoSearch()}}>{t('message.common.btn.view')}</Button>
                                    </TableCell>
                                    <TableCell className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.equipmentNo ? "true" : "false"}
                                            {...register("equipmentNo", {
                                                required : t('message.common.error.text.equipment.number.input')
                                            })} 
                                            sx={{ minWidth: '60%' , backgroundColor: "#fff"}} />
                                        {errors.equipmentNo && <small role="alert"><br></br>{errors.equipmentNo.message}</small>}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.modelName')}</TableCell>
                                    <TableCell className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.modelName ? "true" : "false"}
                                            {...register("modelName", {
                                                required : t('message.common.error.text.modelName.input')
                                            })} 
                                            sx={{ minWidth: '60%', backgroundColor: "#fff" }} />
                                        {errors.modelName && <small role="alert"><br></br>{errors.modelName.message}</small>}
                                    </TableCell>
                                     <TableCell className="th" align="center">{t('message.common.subtitle.installation.location')}</TableCell>
                                    <TableCell colSpan={3} className="email_pl">
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.location ? "true" : "false"}
                                            {...register("location", {
                                                required : t('message.common.error.text.installation.location.input')
                                            })} 
                                            sx={{ minWidth: '60%', backgroundColor: "#fff" }} />
                                        {errors.location && <small role="alert"><br></br>{errors.location.message}</small>}
                                    </TableCell>
                               </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.madeYmd')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="madeYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker
                                                // defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                                                field={field} ref={ref} name={name} value={nowFormat(t('message.common.text.date.format.date'))} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.installation.date')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="instlYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker 
                                                // defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                                                field={field} ref={ref} name={name} value={nowFormat(t('message.common.text.date.format.date'))} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.disposal.date')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            control={control}
                                            name="disposalYmd"
                                            render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                            <CustomDatePicker 
                                                // defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                                                field={field} ref={ref} name={name} value={nowFormat(t('message.common.text.date.format.date'))} register={register} 
                                                setValue={setValue} fieldState={fieldState}
                                            />
                                            )}
                                        />
                                    </TableCell>
                                </TableRow>
                                {/* {(equipmentCategoryLevel1Code && (equipmentCategoryLevel1Code === 'EV' || equipmentCategoryLevel1Code === 'ES')) && */}
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.panel')}</TableCell>
                                    <TableCell className="email_pl">
                                        {liftControlPanels &&
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.controlPanelId ? "true" : "false"}
                                            control={control}
                                            name="controlPanelId"
                                            defaultValue={'0'}
                                            render={({ field }) => (
                                            <CustomFormEquipmentSelect
                                                {...field} // value, onChange, name 등을 전달
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.panel')}
                                                register={register}
                                                // name={name}
                                                requiredMessage={t('message.common.error.text.liftControlPanel.select')}
                                                list={liftControlPanels}
                                            />
                                            )}
                                        />
                                        }
                                        {errors.controlPanelId && <small role="alert"><br></br>{errors.controlPanelId.message}</small>}
                                    </TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.zone')}</TableCell>
                                    <TableCell className="email_pl" colSpan={3}>
                                        {zones &&
                                        <Controller
                                            // sx={{ m: 1, minWidth: "70%" }}
                                            aria-invalid={!isDirty ? undefined : errors.zoneId ? "true" : "false"}
                                            control={control}
                                            name="zoneId"
                                            defaultValue={''}
                                            render={({ field }) => (
                                            <CustomFormEquipmentSelect
                                                {...field} // value, onChange, name 등을 전달
                                                style={{ minWidth: '70%' }}
                                                label={t('message.common.subtitle.zone')}
                                                register={register}
                                                // name={name}
                                                requiredMessage={t('message.common.error.text.zone.select')}
                                                onChangeProp={(e)=>{setSelectManagementCompanyZone(e.target.value)}}
                                                onOpen={(e)=>{
                                                    // console.log(selectManagementCompany)
                                                    if (selectManagementCompany === null || selectManagementCompany === undefined) handleAlertClick(t('message.common.alert.management.company.select'))
                                                }}
                                                list={zones}
                                            />
                                            )}
                                        />
                                        }
                                        {platformServer !== 'NANTONG' && <>&nbsp;&nbsp;<ManagementCompanyZoneWriteLayer managementCompany={selectManagementCompany} managementCompanyZone={managementCompanyZone} setManagementCompanyZone={setManagementCompanyZone} /></>}
                                        {errors.zoneId && <small role="alert"><br></br>{errors.zoneId.message}</small>}
                                    </TableCell>
                                </TableRow>
                                {/* } */}
                                {/* <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.picture.basic')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                    <div style={{display:"flex", justifyContent: "space-between"}}>
                                        <input
                                            type="file" 
                                            accept="image/*" 
                                            onChange={(e)=>
                                                fileChangedHandler(e, 640, 480, setImgFile)
                                            }
                                        />
                                        <div style={{color:"red",fontWeight:"bold"}}>*{t('message.common.text.horizontal.picture.recommend')}</div>
                                    </div>
                                    </TableCell>
                                </TableRow> */}
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.equipment.picture.basic')}
                                        {inputImageItems?.length < 4 && <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addImageFile}>+</AddCircleOutlineIcon>}
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputImageItems.map((item, index) => (
                                        <div key={index} style={{display:"flex"}}>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                value={''}
                                                onChange={e => handleImageFileChange(e, index)}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : (item.imgFile && item.imgFile.id && <><FileDownloadIcon file={item.imgFile} viewFileName={true} fontColor="#000"/></>)}
                                            { inputImageItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteImageFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        ))}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.equipment.picture.drawing')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        <input 
                                            type="file" 
                                            accept="image/*" 
                                            onChange={(e)=>
                                                fileChangedHandler(e, 1920, 1920, setBpFile)
                                            }
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.equipment.picture.vr')}
                                        {inputVRItems.length < 8 && (
                                            <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addVRFile}>+</AddCircleOutlineIcon>
                                        )}
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputVRItems.map((item, index) => (
                                        <div key={index} style={{display:"flex", padding: "4px 5px"}}>
                                            {(index+1)}. 
                                            <input
                                                type="file"
                                                accept="image/*"
                                                value={''}
                                                onChange={(e) => {console.log(3);handleInputVRFileChange(e, index)}}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : (item.vFile && item.vFile.id && <><FileDownloadIcon file={item.vFile} viewFileName={true} fontColor="#000" /></>)}
                                            { inputVRItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteInputVRFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        ))}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">
                                        {t('message.common.subtitle.manual.data')}
                                        <AddCircleOutlineIcon fontSize="small" style={{cursor:"pointer", marginTop:"-3px"}} onClick={addManualFile}>+</AddCircleOutlineIcon>
                                    </TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        {inputManualItems.map((item, index) => (
                                        <div key={index} style={{display:"flex"}}>
                                            <input
                                                type="file"
                                                value={''}
                                                onChange={e => handleManualFileChange(e, index)}
                                            />
                                            {(item.file && item.file.name) ? item.file.name : (item.mFile && item.mFile.id && <><FileDownloadIcon file={item.mFile} viewFileName={true} fontColor="#000"/></>)}
                                            { inputManualItems[index] ? (
                                                <RemoveCircleOutlineIcon fontSize="small" style={{cursor:"pointer"}} onClick={() => deleteManualFile(item.id)}>-</RemoveCircleOutlineIcon>
                                            ) : (
                                            ''
                                            )}
                                        </div>
                                        ))}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.remark')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:"left"}}>
                                        <TextField id="outlined-basic" 
                                            aria-invalid={!isDirty ? undefined : errors.remark ? "true" : "false"}
                                            {...register("remark", {
                                            })} 
                                            sx={{ minWidth: '90%', backgroundColor: "#fff", marginTop: "10px" }} />
                                        <div style={{color:"red",fontWeight:"bold", textAlign:"left"}}>* [{t('message.common.title.comprehensive.report.8.maintenance.main.communication.reflected')}]</div>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.opStatus')}</TableCell>
                                    <TableCell className="email_pl">
                                        <Controller
                                            sx={{ m: 1, minWidth: "90%" }}
                                            aria-invalid={!isDirty ? undefined : errors.opStatus ? "true" : "false"}
                                            control={control}
                                            name="opStatus"
                                            render={({ field: {name} }) => (
                                            <CustomFormEnumSelect
                                                style={{ minWidth: '90%' }}
                                                label={t('message.common.subtitle.opStatus')}
                                                register={register}
                                                name={name}
                                                requiredMessage={t('message.common.error.text.operating.state.select')}
                                                defaultValue={''}
                                                list={getEnumValueByEnumName("EquipmentOpStatus")}
                                            />
                                            )}
                                        />
                                        {errors.opStatus && <small role="alert"><br></br>{errors.opStatus.message}</small>}
                                    </TableCell>
                                    <TableCell colSpan={4}>&nbsp;
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </form>
            </MainCard>

            <div className="btn_right" style={{margin:"8px"}}>
                <LoadingButton variant="contained" color="primary" loading={fileLoading} onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</LoadingButton>
            </div>
        </>
        )
    }
}

export default EquipmentForm;